import { SiTypescript, SiJavascript } from 'react-icons/si';
import { FaAws } from 'react-icons/fa';

import PythonLogo from '../assets/pictures/python-logo.webp';
import CLogo from '../assets/pictures/c-logo.webp';
import CPlusPlusLogo from '../assets/pictures/cplusplus-logo.webp';
import DjangoLogo from '../assets/pictures/django-logo.webp';
import FlaskLogo from '../assets/pictures/flask-logo.webp';
import FastApiLogo from '../assets/pictures/fastapi-logo.webp';
import ReactLogo from '../assets/pictures/react-logo.webp';
import VueLogo from '../assets/pictures/vue-logo.webp';
import AngularLogo from '../assets/pictures/angular-logo.webp';
import DockerLogo from '../assets/pictures/docker-logo.webp';

export const SKILLS = [
  { key: 'python', name: 'Python', img: PythonLogo },
  { key: 'django', name: 'Django', img: DjangoLogo },
  { key: 'flask', name: 'Flask', img: FlaskLogo },
  { key: 'fastapi', name: 'FastAPI', img: FastApiLogo },
  { key: 'javascript', name: 'JavaScript', Icon: SiJavascript, color: '#F7DF1E' },
  { key: 'typescript', name: 'TypeScript', Icon: SiTypescript, color: '#3178C6' },
  { key: 'react', name: 'React', img: ReactLogo },
  { key: 'vue', name: 'Vue', img: VueLogo },
  { key: 'angular', name: 'Angular', img: AngularLogo },
  { key: 'aws', name: 'AWS', Icon: FaAws, color: '#FF9900' },
  { key: 'docker', name: 'Docker', img: DockerLogo },
  { key: 'c', name: 'C', img: CLogo },
  { key: 'cplusplus', name: 'C++', img: CPlusPlusLogo },
];

export const SKILLS_AUTO_SCROLL_INTERVAL_MS = 4500;
export const SKILLS_SCROLL_ANIMATION_DURATION_MS = 800;
